import { ROUTES } from "./constant";

export const PREFERENCE_USER_DETAILS = "USER_DETAILS";

/**
 * Store user details in localStorage
 * @param {Object} userDetails - The user details to store (e.g., token and user data)
 */
export const setUserDetails = (userDetails) => {
  try {
    localStorage.setItem(PREFERENCE_USER_DETAILS, JSON.stringify(userDetails));
  } catch (error) {
    console.error("Error storing user details:", error);
  }
};

/**
 * Retrieve user details from localStorage
 * @returns {Object|null} The user details or null if not found
 */
export const getUserDetails = () => {
  try {
    const data = localStorage.getItem(PREFERENCE_USER_DETAILS);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Error retrieving user details:", error);
    return {};
  }
};

/**
 * Retrieve the authentication token from user details in localStorage
 * @returns {string|null} The auth token or null if not found
 */
export const getAuthToken = () => {
  try {
    const data = getUserDetails();
    return data?.token || null;
  } catch (error) {
    console.error("Error retrieving auth token:", error);
    return null;
  }
};

/**
 * Remove user details from localStorage
 */
export const removeUserDetails = () => {
  try {
    localStorage.removeItem(PREFERENCE_USER_DETAILS);
    window.location.href = ROUTES.ROOT;
  } catch (error) {
    console.error("Error removing user details:", error);
  }
};
